import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { isProductionEnvironment } from "@/lib/environment";
import { useEnvironment } from "@/hooks/useEnvironment";

export function EnvironmentBadge() {
  const { data, isPending, isError } = useEnvironment();

  if (isPending) {
    return (
      <div
        className="flex items-center gap-1.5 text-xs text-muted-foreground"
        aria-busy="true"
        aria-live="polite"
      >
        <Loader2 className="h-3.5 w-3.5 animate-spin shrink-0" aria-hidden />
        <span className="sr-only">Loading environment</span>
      </div>
    );
  }

  if (isError || !data) {
    return (
      <span
        className="text-xs text-muted-foreground"
        title="Could not load environment"
      >
        —
      </span>
    );
  }

  const prod = isProductionEnvironment(data);

  return (
    <div
      role="status"
      aria-label={
        prod
          ? `Production environment: ${data}. Changes may affect live data.`
          : `Non-production environment: ${data}`
      }
      title={
        prod
          ? "You are connected to production. Changes may affect live data."
          : "Non-production environment"
      }
      className={cn(
        "rounded-md border px-2.5 py-1 text-xs font-semibold shadow-sm",
        prod
          ? "border-red-600/70 bg-red-600/15 text-red-800 dark:border-red-500/60 dark:bg-red-950/40 dark:text-red-100"
          : "border-green-600/70 bg-green-600/15 text-green-900 dark:border-green-500/60 dark:bg-green-950/40 dark:text-green-100",
      )}
    >
      {data}
    </div>
  );
}
